import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GruposComponent } from './grupos.component';
import { AdmingComponent } from './adming/adming.component';
import { CreargComponent } from './crearg/crearg.component';
import { RouterModule, Routes } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTabsModule} from '@angular/material/tabs';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { FuseSharedModule } from '@fuse/shared.module';
import {MatSelectModule} from '@angular/material/select';
import {MatExpansionModule} from '@angular/material/expansion';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';

const rutas: Routes = [
    // trust index
    {
        path     : 'focus/wizard/grupos',
        component: GruposComponent,
        canActivate: [AuthGuard]
    }
  ];

@NgModule({
  declarations: [GruposComponent, AdmingComponent, CreargComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    FlexLayoutModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatTableModule,
    MatStepperModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    FuseSharedModule,
    MatSelectModule,
    MatExpansionModule
  ]
})
export class GruposModule {

}
